var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApplicationIntro',{attrs:{"currentStep":2,"currentStepStartHandler":_vm.isFunnel2 ? null : _vm.goToProfile,"blurFutureSteps":"","title":_vm.title,"subtitle":_vm.subtitle,"overrideSteps":_vm.overrideSteps}})
}
var staticRenderFns = []

export { render, staticRenderFns }